import React from 'react';

interface VersionUpdateModalProps {
  isOpen: boolean;
  onRefresh: () => void;
  onDismiss: () => void;
}

const VersionUpdateModal: React.FC<VersionUpdateModalProps> = ({
  isOpen,
  onRefresh,
  onDismiss
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{ zIndex: 10000 }}>
      <div className="modal version-update-modal">
        <div className="modal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ fontSize: '24px' }}>🔄</div>
            <h3 className="modal-title">New Version Available</h3>
          </div>
        </div>
        <div className="modal-body">
          <p style={{ marginBottom: '12px' }}>
            A new version of the application has been deployed with the latest changes and improvements.
          </p>
          <p style={{ color: '#666', fontSize: '14px' }}>
            Please refresh your browser to get the latest version and ensure you have access to all new features.
          </p>
        </div>
        <div className="modal-footer" style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button 
            className="btn btn-outline"
            onClick={onDismiss}
            style={{ minWidth: '100px' }}
          >
            Later
          </button>
          <button 
            className="btn btn-primary"
            onClick={onRefresh}
            style={{ minWidth: '100px' }}
          >
            Refresh Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default VersionUpdateModal;

